module.exports = __webpack_public_path__ + "img/9788971968109.aa428b1e.jpg";